import { NgIf } from '@angular/common';
import { Component, HostListener, signal } from '@angular/core';

@Component({
  selector: 'erp-install-app',
  standalone: true,
  imports: [NgIf],
  template: `
    <div
      *ngIf="showInstall()"
      class="fixed bottom-4 left-4 right-4 z-[1100] rounded-2xl bg-white p-4 shadow-2xl border border-slate-200 md:left-auto md:w-96">
      <h3 class="text-sm font-black text-slate-900">
        Instalar ERP
      </h3>

      <p class="mt-1 text-xs text-slate-500">
        Agrega el ERP a tu pantalla principal para abrirlo como app.
      </p>

      <div class="mt-3 flex gap-2">
        <button class="btn-primary flex-1" type="button" (click)="install()">
          Agregar
        </button>

        <button class="btn-secondary flex-1" type="button" (click)="dismiss()">
          Después
        </button>
      </div>
    </div>
  `
})
export class InstallAppComponent {
  showInstall = signal(false);
  private deferredPrompt: any = null;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event): void {
    event.preventDefault();
    this.deferredPrompt = event;
    this.showInstall.set(this.isMobileOrTablet());
  }

  async install(): Promise<void> {
    if (!this.deferredPrompt) return;

    this.deferredPrompt.prompt();
    await this.deferredPrompt.userChoice;

    this.deferredPrompt = null;
    this.showInstall.set(false);
  }

  dismiss(): void {
    this.showInstall.set(false);
    localStorage.setItem('erp-install-dismissed', '1');
  }

  private isMobileOrTablet(): boolean {
    if (localStorage.getItem('erp-install-dismissed') === '1') return false;

    return /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(navigator.userAgent);
  }
}